<template>
  <v-container fluid>
    <v-row class="justify-center">
      <v-col sm="8" cols="12" md="6">
        <v-card>
          <v-card-title>Nieuwe bestelling </v-card-title>
          <v-card-text>
            <small>{{ motd }}</small>
            <v-alert dense type="warning" v-if="concept.found" dismissible>
              <v-row align="center">
                <v-col class="grow">
                  Uw vorige bestelling was niet afgewerkt
                </v-col>
                <v-col class="shrink">
                  <v-btn small text @click="openConcept">Open</v-btn>
                </v-col>
              </v-row> </v-alert
            ><v-text-field v-model="name" label="Naam"></v-text-field>
            <section v-if="!isAuthenticated">
              <v-checkbox
                v-model="sendSMS"
                label="Stuur een sms bij het bevestingen van mijn bestelling"
              ></v-checkbox>
              <v-text-field
                v-if="sendSMS"
                v-model="phone"
                label="Telefoon"
              ></v-text-field>
            </section>

            <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value.sync="date"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="computedDateFormattedMomentjs"
                  v-model="date"
                  label="Datum"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                locale="nl-be"
                scrollable
                :allowed-dates="allowedDates"
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modal = false">
                  Cancel
                </v-btn>
                <v-btn text color="primary" @click="$refs.dialog.save(date)">
                  OK
                </v-btn>
              </v-date-picker>
            </v-dialog>

            <v-btn
              color="#7cb342"
              :loading="loading.saving"
              style="width: 100%"
              class="white--text"
              @click="openDialog"
              >Product toevoegen</v-btn
            >

            <v-simple-table>
              <tbody>
                <tr
                  v-for="item in items"
                  :key="item.id"
                  @click="openDeleteDialog(item)"
                >
                  <td>{{ item.amount }}</td>
                  <td>{{ item.product }}</td>
                  <td>{{ item.size }}</td>
                  <td>{{ item.pack }}</td>
                </tr>
              </tbody>
            </v-simple-table>
            <v-textarea v-model="note" label="Opmerking" rows="3"></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="teal"
              class="white--text"
              @click="submit"
              :loading="loading.submit"
              :disabled="items.length == 0 || name == ''"
              >Bestelling plaatsen</v-btn
            >
          </v-card-actions>
        </v-card></v-col
      ></v-row
    >
    <NewProductDialog
      :order="id"
      :visible="dialogs.newProduct"
      @close="dialogs.newProduct = false"
    />

    <Confirmation
      v-if="dialogs.deleteItem"
      :visible="dialogs.deleteItem"
      @close="dialogs.deleteItem = false"
      question="Item verwijderen?"
      :subtext="
        clickedItem.amount +
        ' ' +
        clickedItem.product +
        ' ' +
        clickedItem.size +
        ' ' +
        clickedItem.pack
      "
      @confirm="deleteItem"
    />
    <v-snackbar v-model="error.enable" color="error">{{
      error.text
    }}</v-snackbar>
  </v-container>
</template>

<script>
import { auth, firestore } from "firebase";
import moment from "moment";

import NewProductDialog from "@/components/NewProductDialog";
import Confirmation from "@/components/Confirmation";

export default {
  data() {
    return {
      motd: "",
      name: "",
      sendSMS: false,
      phone: "",
      note: "",
      isAuthenticated: false,
      date: new Date().toISOString().substr(0, 10),
      modal: false,
      picker: new Date().toISOString().substr(0, 10),
      dialogs: {
        newProduct: false,
        deleteItem: false,
      },
      clickedItem: null,
      loading: {
        saving: false,
        submit: false,
      },
      saved: false,
      id: "",
      items: [],
      concept: {
        found: false,
        id: "",
      },
      error: {
        enable: false,
        text: "",
      },
    };
  },
  mounted() {
    this.fillName();
    this.checkLast();
    this.fetchMotd();
    this.findFirstDate();
    window.addEventListener("offline", () => console.log("came offline"));
  },
  computed: {
    computedDateFormattedMomentjs() {
      moment.lang("nl");
      return this.date
        ? moment(this.date).lang("nl").format("dddd, MMMM Do YYYY")
        : "";
    },
    formattedPhone() {
      if (this.phone.substr(0, 4) == "0032") {
        return this.phone.replace("0032", "+32");
      } else if (this.phone.substr(0, 2) == "04") {
        return "+32" + this.phone.substr(1);
      } else {
        return this.phone;
      }
    },
  },
  components: {
    NewProductDialog,
    Confirmation,
  },
  watch: {
    name() {
      if (!this.isAuthenticated) {
        if (this.name != "") {
          localStorage.setItem("name", this.name);
        }
      }
    },
    sendSMS() {
      if (!this.isAuthenticated) {
        localStorage.setItem("sendSMS", this.sendSMS ? "yes" : "no");
      }
    },
    phone() {
      if (this.name != "") {
        localStorage.setItem("phone", this.phone);
      }
    },
  },
  methods: {
    async checkLast() {
      let v = localStorage.getItem("lastOrder");
      if (v != null) {
        let o = await firestore().collection("Orders").doc(v).get();
        console.log(o);
        if (o.data().concept) {
          this.concept.found = true;
          this.concept.id = v;
        }
      }
    },
    fillName() {
      this.isAuthenticated = auth().currentUser != null;
      if (!this.isAuthenticated) {
        if (localStorage.getItem("name")) {
          this.name = localStorage.getItem("name");
        }
        if (localStorage.getItem("phone")) {
          this.phone = localStorage.getItem("phone");
        }
        if (localStorage.getItem("sendSMS") == "yes") {
          this.sendSMS = true;
        }
      }
    },
    findFirstDate() {
      let now = moment().format("YYYY-MM-DD");
      for (var i = 0; i <= 14; i++) {
        if (this.allowedDates(now)) {
          this.date = now;
          break;
        } else {
          now = moment(now, "YYYY-MM-DD").add(1, "day").format("YYYY-MM-DD");
        }
      }
    },
    allowedDates(date) {
      let sd = [2, 4, 5];

      let checkDate = moment(date, "YYYY-MM-DD");

      if (checkDate.isAfter(moment())) {
        return sd.includes(checkDate.day());
      } else {
        return false;
      }
    },
    attachListener() {
      let _self = this;
      firestore()
        .collection("Orders/" + this.id + "/items")
        .onSnapshot((list) => {
          _self.items = [];
          list.forEach((item) => {
            _self.items.push({
              id: item.id,
              ...item.data(),
            });
          });
        });
    },
    async openDialog() {
      if (this.saved) {
        this.dialogs.newProduct = true;
      } else {
        try {
          this.loading.saving = true;
          let order = await firestore().collection("Orders").add({
            name: this.name,
            saleDate: this.date,
            placedOn: firestore.FieldValue.serverTimestamp(),
            concept: true,
            accepted: this.isAuthenticated,
            sendSMS: this.sendSMS,
            phone: this.formattedPhone,
            note: this.note,
          });

          this.saved = true;
          this.id = order.id;
          this.openDialog();
          this.attachListener();
          this.loading.saving = false;
          localStorage.setItem("lastOrder", order.id);
        } catch (err) {
          this.error = {
            enable: true,
            text: "Probleem bij het opslaan, controleer internet",
          };
        }
      }
    },
    async submit() {
      this.loading.submit = true;
      if (this.id != "" && this.items.length > 0) {
        await firestore()
          .collection("Orders")
          .doc(this.id)
          .update({
            name: this.name,
            saleDate: this.date,
            note: this.note,
            concept: false,
            sendSMS: this.sendSMS,
            phone: this.formattedPhone,
            box_amount: this.items.reduce((a, b) => +a + +b.amount, 0),
          });

        if (this.isAuthenticated) {
          location.reload();
        } else {
          this.$router.push("/order/success?order=" + this.id);
        }
      } else {
        alert("Alle velden zijn verplicht");
      }
      this.loading.submit = false;
    },
    async deleteItem() {
      await firestore()
        .doc("Orders/" + this.id + "/items/" + this.clickedItem.id)
        .delete();
      this.dialogs.deleteItem = false;
    },
    openDeleteDialog(item) {
      this.clickedItem = item;
      this.dialogs.deleteItem = true;
    },
    async openConcept() {
      this.id = this.concept.id;
      this.attachListener();
      try {
        let o = await firestore().collection("Orders").doc(this.id).get();
        this.name = o.data().name;
        this.saved = true;
        this.concept.found = false;
        this.note = o.data().note;
      } catch (err) {
        this.error = {
          enable: true,
          text: "Kan laatste bestelling niet ophalen",
        };
      }
    },
    async fetchMotd() {
      let settings = await firestore()
        .collection("App-Settings")
        .doc("Orders")
        .get();
      this.motd = settings.data().motd;
    },
  },
};
</script>

<style>
</style>